/* ⚠️ GENERATED from app/services/lastMessage.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/lastMessage.ts — which message a chat row should describe.
//
// 🟥 THREE SURFACES, THREE DIFFERENT ORDERING KEYS, AND TWO OF THEM WERE WRONG.
//    A reply sent AFTER two incoming messages showed up between them in the
//    browser and in the chat list, while the chat itself had it correctly last:
//
//      in the chat  → `_ord`, the local arrival number stamped by THIS device
//      ChatsTab     → `c.timestamp`, overwritten by whoever wrote last
//      the web      → `seq`, falling back to `timestamp`
//
// 🟥 THE SENDER'S WALL CLOCK IS NOT AN ORDERING KEY. Two phones are seconds
//    apart, so a message that genuinely arrived second can carry an EARLIER
//    stamp than one that arrived first. services/messageOrder already says this
//    out loud — "comparing two devices' skewed clocks made already-settled
//    messages swap places" — and then the chat list went and compared them.
//
// 🟢 SO: the server's `seq` when both sides have one, this device's own arrival
//    order when they do not, and the wall clock only as a last resort where
//    there is genuinely nothing else. The first two are the only keys that mean
//    the same thing on both phones and in the browser.

const num = v => {
  if (v == null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

/**
 * Does `next` describe something that happened after `prev`?
 *
 * 🟥 FALSE FOR THE SAME MESSAGE, and that is not a detail. A preview is rewritten
 *    by receipts, by an edit, by a re-delivered snapshot; treating a repeat as
 *    newer is what let a late write of an OLD row clobber a newer one.
 */
export function isNewerThan(next, prev) {
  if (!next) return false;
  if (!prev) return true;
  if (next.id && prev.id && String(next.id) === String(prev.id)) return false;
  const ns = num(next.seq),
    ps = num(prev.seq);
  if (ns != null && ps != null) return ns > ps;
  const no = num(next.ord),
    po = num(prev.ord);
  if (no != null && po != null) return no > po;

  /* 🟥 LAST RESORT, AND ONLY BECAUSE REFUSING EVERY UPDATE WOULD BE WORSE. With
     no seq on either side and no arrival number, there is nothing left that both
     devices agree on. A row that never updates is a worse failure than one that
     occasionally updates out of order, so the clock is used — and the moment
     either side gains a seq, the branch above takes over. */
  /* 🟥 STRICTLY NEWER, SO A TIE KEEPS THE INCUMBENT. Equal stamps are common —
     a chat document and an exported row describing the same moment — and the
     copy already in place is the one holding tombstones and receipts. `>=` here
     let an equal-stamped row displace it and lose them. */
  const nt = num(next.ts) ?? 0,
    pt = num(prev.ts) ?? 0;
  return nt > pt;
}

/**
 * 🟢 A ROW THAT HAS A seq OUTRANKS ONE THAT DOES NOT, whatever the clocks say.
 *    This is the asymmetric case `isNewerThan` deliberately will not guess at:
 *    it is only safe when the seqless row is one THIS device has just been
 *    handed, which the caller knows and the comparator cannot.
 */
export function rankOf(m) {
  const s = num(m?.seq);
  if (s != null) return `s${String(s).padStart(12, '0')}`;
  const o = num(m?.ord);
  if (o != null) return `o${String(o).padStart(12, '0')}`;
  return `t${String(num(m?.ts) ?? 0).padStart(16, '0')}`;
}
